import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { contractColumnData } from '../Data/ColumnData';
import SyncfusionDataTable from 'routes/Pages/SiteAssessment/components/syncfusionDataTable';
import { siteColumnData } from 'routes/Pages/SiteAssessment/Data/ColumnData';
import ConfirmationDialog from 'routes/Pages/Woodchip/components/ConfirmationDialog';
import { TextField } from '@mui/material';
import ContractDocsSection from './ContractDocs';
const ContractInfoDialog = ({
  open,
  handleSiteInfoClose,
  contractInfoData,
  contractMainData,
  handelSiteInfoEdit,
  isSiteAssesmentData = false,
  handleContractStatus,
  saveSiteRef,
  updateFinishDate,
  updateStartDate,
  setShowMap,
  setShowRoute,
}) => {
  const pageSettings = { pageSize: 6 };
  const filterSettings = {
    type: 'Excel',
  };
  const toolbarOptions = ['Search'];
  const handleClose = () => {
    handleSiteInfoClose();
  };

  const [openModal, setOpenModal] = useState(false);
  const [siteRef, setSiteRef] = useState(contractMainData.wH_NumberName);
  const [contractStartDate, setContractStartDate] = useState(contractMainData.startDate);
  const [contractFinishDate, setContractFinishDate] = useState(contractMainData.finishDate);

  let displayCol = isSiteAssesmentData ? siteColumnData : contractColumnData;

  // Function to format a Date object into YYYY-MM-DD string
  const formatDate = dateString => {
    const date = new Date(dateString);
    // Ensure the date object is valid
    if (isNaN(date.getTime())) {
      return ''; // Return an empty string if the date is invalid
    }

    // Get year, month, and day components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  // ... inside your component
  useEffect(() => {
    setSiteRef(contractMainData.wH_NumberName);

    // 💡 FIX: Format the date before setting the state for the TextField
    if (contractMainData.startDate) {
      setContractStartDate(formatDate(contractMainData.startDate));
    }

    if (contractMainData.finishDate) {
      setContractFinishDate(formatDate(contractMainData.finishDate));
    }
  }, [contractMainData]);

  // console.log(contractMainData.contractUniqueID, 'dta');

  const headerUIArray = {
    geolocations: (
      <>
        <Button size="small" variant="contained" color="primary" onClick={() => setShowMap(true)}>
          Show Map
        </Button>
        <Button
          style={{ marginLeft: '1rem' }}
          size="small"
          variant="contained"
          color="primary"
          onClick={() => setShowRoute(true)}>
          Show Route Map
        </Button>
      </>
    ),
  };

  return (
    <>
      <Dialog maxWidth="xl" open={open} onClose={handleClose}>
        <DialogTitle style={{ display: 'flex' }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Typography fontSize="1.5rem" component="div">
              {isSiteAssesmentData ? (
                <>
                  {`Site Assessment Edit : ID - ${contractMainData.siteAssessmentID || ''} `}
                  {contractMainData.flagActive ? (
                    <Chip
                      label="Active"
                      variant="filled"
                      style={{ marginLeft: 8, fontWeight: 600, backgroundColor: '#4caf50', color: '#fff' }}
                    />
                  ) : (
                    <Chip
                      label="Inactive"
                      variant="filled"
                      style={{ marginLeft: 8, fontWeight: 600, backgroundColor: '#ff9800', color: '#fff' }}
                    />
                  )}
                </>
              ) : (
                <>
                  {`Contract View/Edit : ID - ${contractMainData.contractUniqueID || ''} `}
                  {contractMainData.flagActive ? (
                    <Chip
                      label="Active"
                      variant="filled"
                      style={{ marginLeft: 8, fontWeight: 600, backgroundColor: 'oklch(76.8% 0.233 130.85)', color: '#fff' }}
                    />
                  ) : (
                    <Chip
                      label="Inactive"
                      variant="filled"
                      style={{ marginLeft: 8, fontWeight: 600, backgroundColor: 'oklch(79.5% 0.184 86.047)', color: '#fff' }}
                    />
                  )}
                </>
              )}
            </Typography>

            <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={() => setOpenModal(true)}>
              Change contract status
            </Button>
            <Typography style={{ marginLeft: '10px' }}>Contract Ref</Typography>
            <TextField
              value={siteRef}
              onChange={e => setSiteRef(e.target.value)}
              onBlur={e => saveSiteRef(contractMainData, e.target.value)}
              variant="outlined"
              size="small"
              style={{ marginLeft: '16px', width: '250px' }}
            />
            <Typography style={{ marginLeft: '10px' }}>Start</Typography>
            <TextField
              type="date"
              value={contractStartDate}
              onChange={e => setContractStartDate(e.target.value)}
              onBlur={() => updateStartDate(contractMainData, contractStartDate)}
              variant="outlined"
              size="small"
              style={{ marginLeft: '8px', width: '150px' }}
              InputLabelProps={{ shrink: true }}
            />

            {/* End Date */}
            <Typography style={{ marginLeft: '10px' }}>End</Typography>
            <TextField
              type="date"
              value={contractFinishDate}
              onChange={e => setContractFinishDate(e.target.value)}
              onBlur={() => updateFinishDate(contractMainData, contractFinishDate)}
              variant="outlined"
              size="small"
              style={{ marginLeft: '8px', width: '150px' }}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box
            noValidate
            component="div"
            className="SiteInfoDialog"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: '100%',
              height: '70vh',
              gap: '1rem',
            }}>
            {!isSiteAssesmentData && <ContractDocsSection contractUniqueID={contractMainData.contractUniqueID} />}

            {Object.keys(displayCol).map((section, index) => {
              return (
                <SyncfusionDataTable
                  key={index}
                  sectionName={section}
                  columns={displayCol[section]}
                  data={contractInfoData[section]}
                  handelSiteInfoEdit={handelSiteInfoEdit}
                  headerUI={headerUIArray[section]}
                />
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        setOpen={setOpenModal}
        confirmationText={`${
          contractMainData.flagActive
            ? 'Current contract status is - Active. Do you want to inactivate it'
            : 'Current contract status is - Inactive. Do you want to Activate it'
        }`}
        open={openModal}
        confirmationFun={() => handleContractStatus(contractMainData?.contractUniqueID, contractMainData?.flagActive)}
      />
    </>
  );
};

export default ContractInfoDialog;
